import Icon from '../components/Icon.vue'

Icon.register({
  'share-alt-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM304 296c-14.6 0-27.8 5.6-37.8 14.7l-68-40.8c1-3.8 1.7-10 1.7-13.9 0-3.9-0.8-10.1-1.7-13.9l68-40.8c10 9.1 23.2 14.7 37.8 14.7 30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56c0 4.8 0.6 9.5 1.7 13.9l-68 40.8c-10-9.1-23.2-14.7-37.8-14.7-30.9 0-56 25.1-56 56s25.1 56 56 56c14.6 0 27.8-5.6 37.8-14.7l68 40.8c-1 3.8-1.7 10-1.7 13.9v0c0 30.9 25.1 56 56 56s56-25.1 56-56c0-30.9-25.1-56-56-56z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/share-alt-square.js
// module id = 1875
// module chunks = 0